export default function DefaultDatePickerOptions (inline) {
  return {
    'inline': inline,
    'format': 'YYYY/MM/DD',
    'viewMode': 'day',
    'initialValue': false,
    'autoClose': true,
    'position': 'auto',
    'altFormat': 'YYYY/MM/DD',
    'onlyTimePicker': false,
    'onlySelectOnDate': true,
    'calendarType': 'persian',
    'inputDelay': 800,
    'observer': true,
    'calendar': {
      'persian': {
        'locale': 'en',
        'showHint': true,
        'leapYearMode': 'algorithmic'
      },
      'gregorian': {
        'locale': 'en',
        'showHint': true
      }
    },
    'timePicker': {
      'enabled': false
    },
    'dayPicker': {
      'enabled': true,
      'titleFormat': 'YYYY MMMM'
    },
    'monthPicker': {
      'enabled': true,
      'titleFormat': 'YYYY'
    },
    'yearPicker': {
      'enabled': true,
      'titleFormat': 'YYYY'
    },
    'responsive': false
  }
}



// WEBPACK FOOTER //
// ./src/components/DefaultDatePickerOptions.js